import React from "react";
import AntdRate, {RateProps} from "antd/lib/rate";
import { withError} from '@fishx/tracker';

interface RProps extends RateProps {
  forwardedRef?: any;
};
export const Rate: React.FC<RProps> = (props) => {
  const { forwardedRef, ...rest } = props;
  return <AntdRate ref={forwardedRef} {...rest} />;
}
Rate.displayName = 'Rate';
export default withError(Rate,{forwardRef: true});



// WEBPACK FOOTER //
// ./src/components/rate/index.tsx